import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api, { fmtINR, fmtDate } from "@/lib/api";

export default function Transactions() {
  const nav = useNavigate();
  const [tab, setTab] = useState("saving");
  const [list, setList] = useState([]);

  useEffect(() => {
    api.get(`/customer/transactions?wallet=${tab}`).then((r) => setList(r.data));
  }, [tab]);

  return (
    <div data-testid="transactions-page">
      <div className="bg-tenant-gradient text-white px-5 pt-6 pb-6 flex items-center gap-3">
        <button data-testid="header-back" onClick={() => nav(-1)} className="w-9 h-9 rounded-full bg-white/15 grid place-items-center">
          <ArrowLeft className="w-4 h-4" />
        </button>
        <div className="font-extrabold tracking-tight text-lg">Transaction History</div>
      </div>

      <div className="px-5 pt-5">
        <div className="grid grid-cols-2 bg-slate-100 rounded-2xl p-1">
          <button data-testid="tab-saving" onClick={() => setTab("saving")} className={`py-2.5 rounded-xl text-sm font-bold tap-scale ${tab === "saving" ? "bg-white shadow text-tenant-primary" : "text-slate-500"}`}>Saving Wallet</button>
          <button data-testid="tab-bonus" onClick={() => setTab("bonus")} className={`py-2.5 rounded-xl text-sm font-bold tap-scale ${tab === "bonus" ? "bg-white shadow text-violet-700" : "text-slate-500"}`}>Bonus Wallet</button>
        </div>

        <div className="mt-4 space-y-2">
          {list.map((t) => (
            <div key={t.id} data-testid={`tx-${t.id}`} className="bg-white border border-slate-100 rounded-2xl p-3.5 flex items-center justify-between card-shadow">
              <div>
                <div className="font-bold text-sm capitalize">{t.category.replaceAll("_", " ")}</div>
                <div className="text-[11px] text-slate-400">{fmtDate(t.created_at)}</div>
                {t.note && <div className="text-[11px] text-slate-500 mt-0.5">{t.note}</div>}
              </div>
              <div className={`font-extrabold ${t.type === "credit" ? "text-emerald-600" : "text-rose-500"}`}>
                {t.type === "credit" ? "+" : "-"}{fmtINR(t.amount)}
              </div>
            </div>
          ))}
          {list.length === 0 && <div className="text-center text-slate-400 text-sm py-10">No transactions in this wallet.</div>}
        </div>
      </div>
      <div className="h-10" />
    </div>
  );
}
